import { render, staticRenderFns } from "./ModalBuilder.vue?vue&type=template&id=71126ac0"
import script from "./ModalBuilder.vue?vue&type=script&lang=js"
export * from "./ModalBuilder.vue?vue&type=script&lang=js"
import style0 from "./ModalBuilder.vue?vue&type=style&index=0&id=71126ac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports